import { LOCALIZED_PATHS } from '../constants/url-constants';
import { buildLocationSrpPath } from '../location/build-location-srp-path';
import { workModelSegment, type SupportedLocale, type WorkModelKey } from './work-model-hub';

/**
 * Absolute localized path of a work-model page, optionally combined with a curated city, a
 * category slug or a role slug (grammar: jobs / workModel / [alue/city] / [kategoria/slug] /
 * [ammatti/slug]). City is the curated hub slug ("Tampere_Finland"), localized here the same
 * way buildLocationSrpPath does it. Kept apart from work-model-hub.ts so that module stays free
 * of url-constants (which imports it back for localizeRoute).
 */
export function buildWorkModelHubPath(
  key: WorkModelKey,
  locale: SupportedLocale,
  options: { citySlug?: string | null; categorySlug?: string | null; roleSlug?: string | null } = {},
): string {
  let path = `/${locale}/${LOCALIZED_PATHS[locale].jobs}/${workModelSegment(key, locale)}`;
  if (options.citySlug) {
    // buildLocationSrpPath returns `/{jobs}/{alue}/{city}`; only its location tail is wanted here.
    path += buildLocationSrpPath(options.citySlug, locale).replace(/^\/[^/]+/, '');
  }
  if (options.categorySlug) {
    const categorySegment = locale === 'fi' ? 'kategoria' : locale === 'sv' ? 'kategori' : 'category';
    path += `/${categorySegment}/${options.categorySlug}`;
  }
  if (options.roleSlug) {
    const roleSegment = locale === 'fi' ? 'ammatti' : locale === 'sv' ? 'yrke' : 'role';
    path += `/${roleSegment}/${options.roleSlug}`;
  }
  return path;
}
